export default {
  "content": "<path d=\"M18 20H6v-2h12v2zM13 8h5v2h-5v5h-2v-5H6V8h5V3h2v5z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};